import { LocalizedService, RNDService } from '../API/GoMoto';

/**
 * Resolves the display name for an RND service. The ERA-provided name
 * (`description`) always wins when non-blank; otherwise falls back to the
 * localized Admin service name (PMG 674006).
 */
export const getRndServiceDisplayName = (
    rndService: Pick<RNDService, 'description'>,
    localizedService?: { localization: Pick<LocalizedService['localization'], 'name'>; },
): string => (rndService.description?.trim() ? rndService.description : localizedService?.localization.name || '');
